import React from 'react';
import PropTypes from 'prop-types';
import { SuccessIcon, InfoIcon, CloseIcon } from '../../assets';
import {
  Colors,
  Fonts
} from '../../constants';
import { useIsMobile } from '../../recoil';
import { useRecoilValue } from 'recoil';
import { useTealium } from '../../tealium/useTealium';

const styles = {
  toast: {
    display: 'flex',
    height: 60,
    backgroundColor: Colors.GreyScale3,
    borderRadius: '4px 8px 8px 4px',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    borderColor: Colors.AccentBlue4,
    borderLeft: `solid 5px ${Colors.AccentBlue4}`,
    padding: '8px 20px'
  },
  Icon: {
    width: '25px',
    height: '25px'
  },
  toastText: {
    fontFamily: Fonts.Roboto,
    fontSize: 16,
    lineHeight: 1.4
  },
  toastLink: {
    color: Colors.AccentBlue4,
    fontFamily: Fonts.Roboto,
    fontSize: 16,
    lineHeight: 1.4
  },
  linkButton: {
    textDecoration: 'underline'
  }
};

export const ToastItem = ({
  text,
  iconType,
  link,
  clearToast,
  hasCloseButton
}) => {

  const isMobile = useRecoilValue(useIsMobile);
  const { track, events } = useTealium();

  const handleCloseToast = () => {
    clearToast();
  };

  function MapIcon(iconType) {
    switch (iconType) {
      case 'success':
        return SuccessIcon;
      case 'info':
        return InfoIcon;
      default:
        return SuccessIcon;
    }
  }

  const handleViewNow = () => {
    handleCloseToast();
    track(events.applications.quotationViewNow());
    window.location.href = link;
  };

  return (
    <div style={styles.toast}>
      <img style={styles.Icon} src={MapIcon(iconType)} alt='Toast Icon' />
      <div style={isMobile ? { ...styles.toastText, fontSize: 14 } : styles.toastText}>
        {text}
      </div>
      <div style={isMobile ? { ...styles.toastLink, fontSize: 14 } : styles.toastLink}>
        {link && <button style={styles.linkButton} onClick={handleViewNow}>View now</button>}
      </div>
      {hasCloseButton && <img
        style={{ ...styles.Icon, cursor: 'pointer', width: '32px', height: '32px' }}
        src={CloseIcon}
        onClick={handleCloseToast}
        alt='Toast Icon'
      />
      }
    </div>
  );
};

ToastItem.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
  hasCloseButton: PropTypes.bool,
  clearToast: PropTypes.func,
  iconType: PropTypes.string
};